import Vue from "vue"
import Router from "vue-router"

//user
import User from "./views/user/Index"
import Login from "./views/user/Login"
import Register from "./views/user/Register"
import ForgetPassword from "./views/user/ForgetPassword"
import Info from "./views/user/Info"
//用户隐私协议
import UserSecrets from "./views/user/userSecrets";
//用户服务协议
import serverAgreement from "./views/user/serverAgreement";

//team
import Team from "./views/team/Team"
import ItemList from "./views/team/ItemList"
import GroupSelect from "./views/team/GroupSelect.vue"

//item
import DesignList from "./views/item/DesignList"
import Search from "./views/item/Search"

//desgin
import Design from "./views/design/Design"
import Proto from "./views/design/Proto"
import Comment from "./views/design/Comment"

//other
import Kefu from "./components/base/Kefu"
import Share from "./mobile/Share"
import sheet from "./components/common/Actionsheet.vue"



Vue.use(Router)

var router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: "/user/login"
        },
        {
            path: "/kefu",
            name: "kefu",
            component: Kefu
        },
        {
            path: "/share",
            name: "share",
            component: Share
        },
        {
            path: "/user",
            name: "user",
            component: User,
            redirect: "/user/login",
            children: [
                {
                    path: "login",
                    name: "login",
                    component: Login
                },
                {
                    path: "register",
                    name: "register",
                    component: Register
                },
                {
                    path: "forget",
                    name: "forget",
                    component: ForgetPassword
                },
                {
                    path: "info",
                    name: "info",
                    component: Info
                },
                {
                    path: "sheet",
                    name: "sheet",
                    component: sheet
                },
                {
                    path: "secrets",
                    name: "secrets",
                    component: UserSecrets
                },
                {
                    path: "serverAgreement",
                    name: "serverAgreement",
                    component: serverAgreement
                },
            ]
        },
        {
            path: "/team",
            component: Team,
            redirect: "/team/items",
            children: [
                {
                    path: "items",
                    name: "team",
                    component: ItemList,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: "group",
                    name: "group",
                    component: GroupSelect
                },
                {
                    path: "item",
                    name: "item",
                    component: DesignList,
                    children: [
                        {
                            path: "search",
                            name: "search",
                            component: Search
                        },
                        {
                            path: "design",
                            name: "design",
                            component: Design
                        },
                        {
                            path: "design/proto",
                            name: "proto",
                            component: Proto
                        },
                        {
                            path: "design/comment",
                            name: "comment",
                            component: Comment
                        }
                    ]
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (localStorage.token) {
        if (to.name == "entering" || to.name == "login") {
            router.push("team")
        }
    }

    if (from.name == "proto" && from.query.image_id && to.name !== "design") {
        localStorage.backtoproto = "true"
        localStorage.lastProto = from.query.image_id
    } else {
        localStorage.backtoproto = ""
    }

    next()
})

export default router
